// graphql __typename
export const PROJECT_FIELD = 'JiraProjectField';
export const ISSUE_TYPE_FIELD = 'JiraIssueTypeField';
export const REQUEST_TYPE_FIELD = 'JsmRequestTypeField';
export const TEXT_FIELD = 'JiraSingleLineTextField';
export const RICH_TEXT_FIELD = 'JiraRichTextField';
export const COMPONENTS_FIELD = 'JiraComponentsField';
export const DATA_CLASSIFICATION_FIELD = 'JiraDataClassificationField';
export const USER_PICKER_FIELD = 'JiraSingleSelectUserPickerField';
export const MULTI_USER_PICKER_FIELD = 'JiraMultipleSelectUserPickerField';
export const PEOPLE_FIELD = 'JiraPeopleField';
export const JSM_PEOPLE_FIELD = 'JsmPeopleField';
export const NUMBER_FIELD = 'JiraNumberField';
export const DATE_TIME_FIELD = 'JiraDateTimePickerField';
export const EPIC_LINK_FIELD = 'JiraEpicLinkField';
export const LABEL_FIELD = 'JiraLabelsField';
export const VERSION_FIELD = 'JiraSingleVersionPickerField';
export const MULTI_VERSION_FIELD = 'JiraMultipleVersionPickerField';
export const PRIORITY_FIELD = 'JiraPriorityField';
export const ISSUE_LINK_FIELD = 'JiraIssueLinkField';
export const DATE_PICKER_FIELD = 'JiraDatePickerField';
export const SECURITY_FIELD = 'JiraSecurityLevelField';
export const URL_FIELD = 'JiraUrlField';
export const CHECKBOX_FIELD = 'JiraCheckboxesField';
export const RADIO_FIELD = 'JiraRadioSelectField';
export const SINGLE_SELECT_FIELD = 'JiraSingleSelectField';
export const MULTI_SELECT_FIELD = 'JiraMultipleSelectField';
export const SINGLE_GROUP_PICKER_FIELD = 'JiraSingleGroupPickerField';
export const MUTLI_GROUP_PICKER_FIELD = 'JiraMultipleGroupPickerField';
export const SPRINT_FIELD = 'JiraSprintField';
export const COLOR_FIELD = 'JiraColorField';
export const ATTACHMENTS_FIELD = 'JiraAttachmentsField';
export const ISSUE_RESTRICTION_FIELD = 'JiraIssueRestrictionField';
export const RESOLUTION_FIELD = 'JiraResolutionField';
export const CASCADING_SELECT_FIELD = 'JiraCascadingSelectField';
export const TEAM_FIELD = 'JiraTeamField';
export const AFFECTED_SERVICES_FIELD = 'JiraAffectedServicesField';
export const JSM_MULTI_USER_PICKER_FIELD = 'JsmMultipleSelectUserPickerField';
export const CMDB_FIELD = 'JiraCMDBField';
export const ORGANIZATIONS_FIELD = 'JsmOrganizationField';
export const CONNECT_TEXT_FIELD = 'JiraConnectTextField';
export const CONNECT_NUMBER_FIELD = 'JiraConnectNumberField';
export const CONNECT_SINGLE_SELECT_FIELD = 'JiraConnectSingleSelectField';
export const CONNECT_MULTI_SELECT_FIELD = 'JiraConnectMultipleSelectField';
export const TIME_TRACKING_FIELD = 'JiraTimeTrackingField';
export const LOG_WORK_FIELD = 'JiraWorkLogField';
export const CONNECT_RICH_TEXT_FIELD = 'JiraConnectRichTextField';
export const FORGE_STRING_FIELD = 'JiraForgeStringField';
export const FORGE_NUMBER_FIELD = 'JiraForgeNumberField';
export const FORGE_USER_PICKER_FIELD = 'JiraForgeUserField';
export const FORGE_MULTI_USER_PICKER_FIELD = 'JiraForgeUsersField';
export const FORGE_GROUP_PICKER_FIELD = 'JiraForgeGroupField';
export const FORGE_MULTI_GROUP_PICKER_FIELD = 'JiraForgeGroupsField';
export const FORGE_STRINGS_FIELD = 'JiraForgeStringsField';
export const FORGE_DATETIME_FIELD = 'JiraForgeDatetimeField';
export const FORGE_DATE_FIELD = 'JiraForgeDateField';
export const FORGE_OBJECT_FIELD = 'JiraForgeObjectField';
export const ATLASSIAN_TEAM_FIELD = 'JiraAtlassianTeamField';
export const PARENT_LINK_FIELD = 'JiraParentIssueField';
export const PARENT_FIELD = 'JiraParentField';
export const RESPONDERS_FIELD = 'JiraServiceManagementRespondersField';
export const ENTITLEMENT_FIELD = 'JiraServiceManagementEntitlementField';
export const ORGANIZATION_FIELD = 'JiraCustomerServiceOrganizationField';

// type overrides (these are some types that we have created on FE side to handle fields with special behaviour)
export const MESSAGE_EDIT_FIELD = 'JiraMessageEditField';
export const ASSIGNEE_FIELD = 'JiraAssigneeField';
export const REPORTER_FIELD = 'JiraReporterField';
export const TEXT_AREA_FIELD = 'JiraTextAreaField';
export const EPIC_COLOR_FIELD = 'JiraEpicColorField';
export const ASSET_FIELD = 'JiraAssetField';
